import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fgManageForecastTreeData: [],
  fgManageForecastBottlerData: {
    bottler: null,
    bottlerOwnerCode: null,
  },
  fgManageForecastFinalTreeData: [],
};

const FGManageScreenRedux = createSlice({
  name: "FGManageScreenRedux",
  initialState,
  reducers: {
    setFGManageForecastTreeData: (state, action) => {
      state.fgManageForecastTreeData = action.payload;
    },
    setFGManageForecastBottlerData: (state, action) => {
      state.fgManageForecastBottlerData = action.payload;
    },
    setFGManageForecastFinalTreeData: (state, action) => {
      state.fgManageForecastFinalTreeData = action.payload;
    },
  },
});

export const {
  setFGManageForecastTreeData,
  setFGManageForecastBottlerData,
  setFGManageForecastFinalTreeData,
} = FGManageScreenRedux.actions;
export default FGManageScreenRedux.reducer;
